// extracted by mini-css-extract-plugin
module.exports = {"news":"da51a739f7--news--hVum4","news__title":"da51a739f7--news__title--PoR60"};